import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CreateFuneral from "./pages/CreateFuneral";
import MyFunerals from "./pages/MyFunerals";
import FuneralDetail from "./pages/FuneralDetail";
import AdminDashboard from "./pages/AdminDashboard";
import Gallery from "./pages/Gallery";
import { Toaster } from "./components/ui/sonner";
import { usePageView } from "./hooks/usePageView";

function PageViewTracker() {
  usePageView();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PageViewTracker />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route 
              path="/create" 
              element={
                <ProtectedRoute>
                  <CreateFuneral />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-funerals" 
              element={
                <ProtectedRoute>
                  <MyFunerals />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/funeral/:shareCode" element={<FuneralDetail />} />
          </Routes>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
